import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    preload: ["en", "ar"],
    defaultNS: "common",
    ns: [
      "common",
      "nav",
      "forms",
      "validation",
      "dropdowns",
      "tables",
      "alerts",
      "pageTitle",
      "cashSafe",
    ],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
  });

export default i18n;
